import { FullScreenBox } from '@aibees/shared/components/full-screen-box';
import { Export } from './components/export';

export function FileView() {
  return (
    <FullScreenBox>
      <Export />
    </FullScreenBox>
  );
}
